/**
 * @generated SignedSource<<af3168bd7a11f39b9ff4ec101a7ecae7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type FileIconBox_file$data = {
  readonly isOrg: boolean;
  readonly type: FileType | null;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
  readonly " $fragmentType": "FileIconBox_file";
};
export type FileIconBox_file$key = {
  readonly " $data"?: FileIconBox_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileIconBox_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileIconBox_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FileIcon_File"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "ffa466502e8ecd24db1c720109af4097";

export default node;
